module.exports = __webpack_public_path__ + "static/media/Frame 82 (2).42ecb936.png";